import {
  validateRequired,
  validateRequiredForCheckbox,
} from 'hb-react/shared/utils/validators/required';

export const validateCheckbox = ({
  isStringValue,
  required,
  value,
}: {
  isStringValue: boolean;
  required: boolean;
  value: boolean | string;
}) => {
  let error;

  if (required) {
    error = isStringValue
      ? validateRequiredForCheckbox(value)
      : validateRequired(value);
  }

  return error;
};
